import { render, staticRenderFns } from "./CampaignMessageHelper.vue?vue&type=template&id=e649d2f4&scoped=true"
import script from "./CampaignMessageHelper.vue?vue&type=script&lang=js"
export * from "./CampaignMessageHelper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e649d2f4",
  null
  
)

export default component.exports